export default [
  {
    path: 'challenge-not-found',
    name: 'challenge-not-found',
    component: () => import('@/views/challenge/ChallengeNotFound.vue'),
    meta: {
      bypassAuth: true,
      // No `layout` override: it was the string 'OneColumnLayout', which <component :is>
      // can't resolve, so the page rendered without the layout's <main id="main"> and the
      // skip link had a dead target (2.4.1). Inherits the parent's ChallengeLayout instead.
      renderNav: false,
      renderFooter: false,
      title: 'Challenge Not Found',
    },
  },
  {
    path: 'room',
    name: 'challenge-room',
    component: () => import('@/views/challenge/views/ChallengeView.vue'),
    meta: {
      bypassAuth: true,
      title: 'Challenge',
      renderFooter: false,
    },
  },
  {
    path: ':code',
    name: 'challenge-waiting-room',
    component: () => import('@/views/challenge/Challenge.vue'),
    meta: {
      bypassAuth: true,
      title: 'Challenge',
      renderFooter: false,
    },
  },
  {
    path: 'outage/:rescheduledate',
    name: 'challenge-outage',
    component: () => import('@/views/challenge/views/ChallengeOutage.vue'),
    meta: {
      bypassAuth: true,
      renderFooter: false,
      title: 'Outage',
    },
  },
  {
    path: 'audio-video-test/:code',
    name: 'challenge-audio-video-test',
    component: () => import('@/views/challenge/views/AudioVideoTest.vue'),
    meta: {
      bypassAuth: true,
      renderFooter: false,
      title: 'Audio/Video Test',
    },
  },
  // {
  //   path: 'test',
  //   name: 'challenge-test',
  //   component: () => import('@/views/challenge/views/ChallengeView.vue'),
  //   meta: {
  //     bypassAuth: true,
  //   },
  // },
];